import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { DateRange, MatDatepickerModule, MatDateRangeInput, MatDateRangePicker } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatDialog } from "@angular/material/dialog";
import { OverlayModule } from "@angular/cdk/overlay";
import { AppointmentsFilterService } from '../../../services/appointments/appointments-filter.service.js';
import { AppointmentsService } from '../../../services/appointments/appointments.service.js';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';

/** Controls for the appointments list page. This contains controlling search, provider, and date filters */
@Component({
	selector: 'app-appointments-filter',
	imports: [
		MatInputModule,
		MatButtonModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		OverlayModule,
		MatPaginatorModule,
		MatDateRangeInput
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './appointments-controls.component.html',
	styleUrl: './appointments-controls.component.scss'
})
export class AppointmentsControls implements OnInit {

  dateRangeControl: FormGroup;

	/** global search */
	globalSearch: FormControl<string>;

	/** The search control on the page */
	searchControl = new FormControl<string>('');

	/** Is the search feature hidden or shown? */
	isSearchOpen: boolean = false;

	/** Dispatched when the search filter changes */
	@Output()
	readonly searchChange = new EventEmitter<string>();

	@ViewChild(MatPaginator)
	private paginator: MatPaginator;

	constructor(private appointmentsService: AppointmentsService,
		private appointmentsFilterService: AppointmentsFilterService,
		private matDialog: MatDialog) {
	}

	ngOnInit(): void {

		this.dateRangeControl = new FormGroup({
	    start: new FormControl<Date | null>(this.appointmentsFilterService.startDate),
  	  end: new FormControl<Date | null>(this.appointmentsFilterService.endDate),
	  });

		this.dateRangeControl.valueChanges.subscribe((value) => this.appointmentsFilterService.dateRange = value);

		this.globalSearch = new FormControl<string>('');

		this.searchControl.valueChanges.subscribe(value => this.searchChange.emit(value));
	}

	async onEnterKey() {
	if(!this.globalSearch.getRawValue()) {
			this.appointmentsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}

	async clickGlobalSearchX(event: MouseEvent) {
		if((event as PointerEvent).pointerId > 0) {
			this.globalSearch.reset(null);
			this.appointmentsFilterService.globalSearch = this.globalSearch.getRawValue();
		} else {
			this.appointmentsFilterService.globalSearch = this.globalSearch.getRawValue();
		}
	}

	/** Reset the search filter */
	resetSearch() {
		this.searchControl.setValue('');
		this.searchChange.emit(this.searchControl.value);
	}

	onPageChange(event: PageEvent) {
		this.appointmentsFilterService.pageEvent = event;
	}

	setTotal(total: number) {
		this.paginator.length = total;
	}
}
